interface GraphDownArrowWithDollarSign2SVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphDownArrowWithDollarSign2SVG = ({
  color,
  style,
}: GraphDownArrowWithDollarSign2SVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
  >
    <g clipPath="url(#clip0_1273_18629)">
      <path
        d="M3.55908 13.2843H9.46237V45.4411"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.3096 31.5976H18.2129V45.4411"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M21.0591 36.9821H26.9643V45.4411"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M29.8105 39.7396H35.7138V45.4411"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M0.710938 2.2887V48.2871H46.7093"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.1372 39.2131L46.7092 33.8575L40.1372 28.5038V32.9927"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0054 13.2843C16.0054 24.1685 24.8296 32.9927 35.7138 32.9927H40.1374"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.7091 13.2843C46.7091 19.3567 41.7858 24.28 35.7134 24.28C29.641 24.28 24.7178 19.3567 24.7178 13.2843C24.7178 7.21195 29.641 2.2887 35.7134 2.2887C41.7858 2.2887 46.7091 7.21195 46.7091 13.2843Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.0423 10.3846C37.9508 7.4752 33.0275 7.8211 32.991 10.8515C32.9737 12.2063 34.5629 12.8308 35.8927 13.0403C40.7333 13.8051 39.3959 18.3575 35.8927 18.1845C33.2332 18.0539 32.4664 16.2552 32.3838 15.8267"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.9497 5.93982V8.38031"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.9497 18.1903V20.6308"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1273_18629">
        <rect width="49" height="49" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GraphDownArrowWithDollarSign2SVG;
